import React, { useState } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { Button, ToggleText } from '../../../components';
import { USER_BIO } from '../config';
import { getHeightByNumberOfLines } from '../../../util/data';
import { WarningIcon } from '../../../icons';
import { BIO_ID } from '../NavigationBar';
import sectionCss from './BioSection.css';
import css from '../ProfileSettingsForm.css';
import LogoutOverlay from '../LogoutOverlay';

const BIO_NUMBER_OF_LINES = 3;

const BioSection = ({
    renderEditPencilIcon,
    handleEditSection,
    isPublic,
    displayName,
    bio,
    isLoggedOut,
    isRider,
    switchUserRoleAction,
    pageParams,
}) => {
    const [bioRef, setBioRef] = useState(null);

    const headingMessage = (
        <FormattedMessage
            id={`ProfileSettingsForm.bioHeading-${isPublic && displayName ? 'public' : 'preview'}`}
            values={{ displayName }}
        />
    );

    if (isPublic && !isLoggedOut && !bio) {
        return (
            <div className={css.infoBlock}>
                <h2 className={css.infoHeading}>{headingMessage}</h2>
                <p className={css.noData}>{displayName} hat noch keine Beschreibung hinzugefügt.</p>
            </div>
        );
    }

    if (isPublic && isLoggedOut && !bio) return null;

    const bioToggleMaxHeight = bioRef
        ? getHeightByNumberOfLines(bioRef, BIO_NUMBER_OF_LINES)
        : { isExceeded: true, refMaxHeight: 0 };

    const logoutOverlayVisible = isLoggedOut || switchUserRoleAction;
    const emptyNonPublic = !bio && !isPublic;
    const nonEmptyNonPublic = bio && !isPublic;

    const classes = classNames({
        [css.infoBlock]: true,
        [css.noInfoBlock]: emptyNonPublic,
        [css.viewProfileRequestWrapper]: logoutOverlayVisible,
        [sectionCss.viewProfileRequestWrapper]: logoutOverlayVisible,
    });

    return (
        <div className={classes} id={BIO_ID}>
            <h2 className={css.infoHeading}>
                {headingMessage}
                {emptyNonPublic && isRider ? (
                    <WarningIcon rootClassName={css.noInfoWarningIcon} />
                ) : null}
                {nonEmptyNonPublic && (
                    <div className={css.editBlock}>
                        {renderEditPencilIcon(
                            USER_BIO,
                            null,
                            <p className={css.editText}>
                                <FormattedMessage id="ProfileSettingsForm.editText" />
                            </p>
                        )}
                    </div>
                )}
            </h2>
            {/* User added his bio */}
            {bio && (
                <ToggleText
                    initialState={isLoggedOut}
                    rootClass={sectionCss.bio}
                    maxHeight={bioToggleMaxHeight.refMaxHeight}
                >
                    <p ref={setBioRef}>{bio}</p>
                </ToggleText>
            )}
            {/* User has no bio and it's his own page */}
            {emptyNonPublic && (
                <>
                    <div className={sectionCss.placeholder} />
                    <div className={sectionCss.placeholder} />
                    <div className={sectionCss.placeholder} />

                    <Button
                        type="button"
                        onClick={() => {
                            handleEditSection(USER_BIO);
                        }}
                        className={`${css.actionItem} ${css.actionBtn}`}
                    >
                        <FormattedMessage id="ProfileSettingsForm.editUserInfoAction-userDescription" />
                    </Button>
                </>
            )}
            <LogoutOverlay
                userName={displayName}
                isLoggedOut={isLoggedOut}
                rootClassName={sectionCss.viewProfileRequestAction}
                sectionName={USER_BIO}
                switchUserRoleAction={switchUserRoleAction}
                pageParams={pageParams}
            />
        </div>
    );
};

export default BioSection;
